import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.css']
})
export class LoginPageComponent implements OnInit {

  constructor(
    private router: Router,
    private shopSettingsService: ShopSettingsService,
  ) {
  }

  ngOnInit(): void {
  }

  onLoggedIn(): void {
    this.router.navigate(['']);
  }

  register(): void {
    this.router.navigateByUrl('/registration');
  }

  get allowedRegistration(): boolean {
    return this.shopSettingsService.allowedRegistration;
  }

  get showRememberMe(): boolean {
    return !this.shopSettingsService.isVUMode && !this.shopSettingsService.shopSettings.logoutByTimeout;
  }
}
